/**
 * LocalStorage Transport
 * 
 * Simple persistence: any "state.*" event is saved to localStorage.
 * Hydration is handled in core/boot.ts by reading back these keys.
 */

import type { Transport } from '../transport.js';

/**
 * LocalStorage transport for persisting state events.
 * Automatically saves any "state.*" events to localStorage for hydration on app start.
 */
export class LocalStorageTransport implements Transport {
  name = 'LocalStorageTransport';

  connect(): void {
    // No async initialization needed for localStorage
  }

  disconnect(): void {
    // No cleanup needed
  }

  send(event: string, payload: unknown): void {
    if (event.startsWith('state.')) {
      const key = event.slice('state.'.length);
      try {
        localStorage.setItem(`pivot:${key}`, JSON.stringify(payload));
      } catch {
        // Storage may be full or disabled
      }
    }
  }

  onMessage?: (event: string, payload: unknown) => void;
}

